import React from 'react';
import SmallLoader from '@/ui/SmallLoader';

function ScoreboardLoading() {
    return (
        <div className="flex-center" style={{ height: '84px' }}>
            <SmallLoader />
        </div>
    );
}

export default ScoreboardLoading;
